import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "bg-primary/15 text-primary border border-primary/20",
        secondary:
          "bg-secondary text-secondary-foreground border border-border/50",
        destructive:
          "bg-rose-100 text-rose-700 border border-rose-200/60",
        outline:
          "border border-border text-foreground bg-transparent",
        success:
          "bg-emerald-100 text-emerald-800 border border-emerald-200/60",
        warning:
          "bg-amber-100 text-amber-800 border border-amber-200/60",
        info:
          "bg-sky-100 text-sky-800 border border-sky-200/60",
        muted:
          "bg-slate-100 text-slate-600 border border-slate-200/60",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
